//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { ItemBase } from '../internal/ItemBase';
import { AttendanceDisplayItem } from './AttendanceDisplayItem';
import { CalendarAttendanceDisplayItem } from './CalendarAttendanceDisplayItem';
import { EventCategoryDisplayItem } from './EventCategoryDisplayItem';
import { EventLocationDisplayItem } from './EventLocationDisplayItem';
import { RepeatDetailsItem } from './RepeatDetailsItem';
import { RegistrationEligibilityDisplayItem } from './RegistrationEligibilityDisplayItem';
import { TeacherCalendarDisplayItem } from './TeacherCalendarDisplayItem';
import { PricePerParticipantTypeEnum } from './Enums';

export class CalendarEventDisplayItem extends ItemBase {
    AllDay: boolean = false;
    AttendancesFull: AttendanceDisplayItem[] = [];
    Attendances: CalendarAttendanceDisplayItem[] = [];
    CurrentNumberAttending: number = 0;
    Description: string | null = null;
    DisplayDescriptionOnCalendar: boolean = false;
    Duration: number = 0;
    EndDate: string = "1970-01-01T00:00:00";
    EventCategory: EventCategoryDisplayItem | null = null;
    EventLocation: EventLocationDisplayItem | null = null;
    ID: string | null = null;
    EventTaxIDs: string[] = [];
    GroupNote: string | null = null;
    TeacherGroupNote: string | null = null;
    IsPublic: boolean = false;
    MakeupRequired: boolean = false;
    MaximumNumberOfParticipants: number = 0;
    NextEventID: string | null = null;
    PricePerParticipantType: PricePerParticipantTypeEnum = PricePerParticipantTypeEnum.ParticipantDefaultPrice;
    PricePerParticipant: number | null = null;
    PrivateDescription: string | null = null;
    Recurring: boolean = false;
    RepeatDetails: RepeatDetailsItem | null = null;
    SeriesID: string | null = null;
    StartDate: string = "1970-01-01T00:00:00";
    CanConvertToMakeUp: boolean = false;
    CanConvertToOpen: boolean = false;
    StudentRegistrationOptions: RegistrationEligibilityDisplayItem[] = [];
    TotalSpacesAvailable: number | null = null;
    OriginalTeacherID: string | null = null;
    TeacherID: string | null = null;
    OriginalTeacher: TeacherCalendarDisplayItem | null = null;
    Teacher: TeacherCalendarDisplayItem | null = null;
    HoldTimeSlot: boolean = false;

    constructor(initializer?: Partial<CalendarEventDisplayItem>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    static readonly ClassName: string = "CalendarEventDisplayItem";
}
